import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidacaoMensagemComponent } from './validacao.mensagem.component';
import { ValidacaoService } from './validacao.service';
import { FormsModule }    from '@angular/forms';

/** AngularMaterial **/
import { MatExpansionModule, MatProgressBarModule, MatCardModule} from '@angular/material';
import { PagerComponent} from "../paginator/pager.component";



/**
Tive que criar esse módulo, pq se eu usasse o validacao.module, iria Dar dependencia circular
**/

@NgModule({
    declarations: [
      ValidacaoMensagemComponent
    ],
    exports: [
      ValidacaoMensagemComponent
    ],
    imports: [
      FormsModule, CommonModule,
      MatExpansionModule, MatProgressBarModule, MatCardModule

    ],
    providers: [
      ValidacaoService
    ]
})
export class ValidacaoMensagemModule {

}
